<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4>Seguro Fiança</h4>
      <div>
        <strong style="font-size:20px;">Pasta:</strong> {{ pasta }} |
        <strong  style="font-size:20px;">Referência do Imóvel:</strong> {{ referencia }}
      </div>
    </div>

    <div class="row mb-4 text-center">
     <div class="col">
    <router-link :to="`/locacao/${pasta}`">
      <img src="/img/ficha.png" alt="Ficha" class="icon-menu" /> </router-link>
      <p class="link-locacao">FICHA</p>
   
  </div>

  <div class="col">
    <router-link :to="`/boletos/${pasta}`">
      <img src="/img/boletos.png" alt="Boletos" class="icon-menu" />   </router-link>
      <p  class="link-locacao">BOLETOS</p>
 
  </div>

  <div class="col">
    <router-link :to="`/repasses/${pasta}`">
      <img src="/img/repasses.png" alt="Repasses" class="icon-menu" /> </router-link>
      <p  class="link-locacao">REPASSES</p>
   
  </div>

  <div class="col">
    <router-link :to="`/iptuClientes/${pasta}`">
      <img src="/img/iptu.png" alt="IPTU" class="icon-menu" /> </router-link>
      <p  class="link-locacao">IPTU</p>
   
  </div>
  <div class="col">
    <router-link :to="`/seguroFianca/${pasta}`">
      <img src="/img/seguro.png" alt="SEGURO" class="icon-menu" /> </router-link>
      <p  class="link-locacao">SEGURO</p>
   
  </div>

  <div class="col">
    <router-link :to="`/relatorios/${pasta}`">
      <img src="/img/relatorios.png" alt="Relatórios" class="icon-menu" /> </router-link>
      <p  class="link-locacao">RELATÓRIOS</p>
   
  </div>

    </div>

    <h5 class="text-center text-uppercase mb-4">Parâmetros para Emissão</h5>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label>Valor da parcela:</label>
        <input type="text" v-model="valorParcela" v-money="money" class="form-control" />
      </div>

      <div class="col-md-4 mb-3">
        <label>Total de parcelas:</label>
        <input type="number" v-model="totalParcelas" class="form-control" />
      </div>

      <div class="col-md-4 mb-3">
        <label>Parcelas em aberto:</label>
        <input type="number" v-model="parcelasAbertas" class="form-control" />
      </div>

     <div class="col-md-4 mb-3">
  <label>Saldo em aberto:</label>
  <input 
    type="text" 
    class="form-control" 
    :value="saldoAbertoFormatado" 
    readonly 
  />
</div>

      <div class="col-md-4 mb-3">
        <label>Último pagamento:</label>
        <input type="date" v-model="ultimoPagamento" class="form-control" />
      </div>
    </div>

    <div class="text-center mt-4">
      <button @click="salvarSeguro" class="btn btn-success px-4 py-2">
        SALVAR
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VMoney } from "v-money";

export default {
  name: "SeguroFianca",
  directives: { money: VMoney },
  data() {
    return {
      pasta: "",
      referencia: "",
      valorParcela: "",
      totalParcelas: "",
      parcelasAbertas: "",
   
      ultimoPagamento: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
    };
  },
  mounted() {
      this.pasta=this.$route.params.id;
      this.get();
  },
  computed: {
  saldoAbertoCalc() {
    const valorParcela = parseFloat(
      (this.valorParcela || "0")
        .replace(/[R$\s.]/g, "")
        .replace(",", ".")
    );
    const parcelasAbertas = parseInt(this.parcelasAbertas || 0);
    return valorParcela * parcelasAbertas;
  },
  saldoAbertoFormatado() {
    if (isNaN(this.saldoAbertoCalc)) return "R$ 0,00";
    return this.saldoAbertoCalc
      .toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }
},
  methods: {
       get(){
      axios.post('https://www2.royaljardim.com.br/sistema/locacao/getLocacao',{pasta:this.pasta})
        .then(r=>this.updateInfo(r.data))
    },
     updateInfo(data){
           this.pasta=data.LOC_PASTA||'';
           this.referencia=data.LOC_IMOVEL||'';
              this.valorParcela=data.LOC_SEGURO_VALOR||'0,00';
                 this.totalParcelas=data.LOC_SEGURO_TOTAL_PARCELAS||'0';
                   this.parcelasAbertas=data.LOC_SEGURO_PARCELAS_ABERTAS||'0';
                    this.ultimoPagamento=data.LOC_SEGURO_ULTIMO_PAGAMENTO||'';
     },
    salvarSeguro() {
      const formData = new FormData();
      formData.append("pasta", this.pasta);
      formData.append("referencia", this.referencia);
      formData.append("valorParcela", this.valorParcela.replace(/[R$\s.]/g, "").replace(",", "."));
      formData.append("totalParcelas", this.totalParcelas);
      formData.append("parcelasAbertas", this.parcelasAbertas);
      formData.append("saldoAberto", this.saldoAbertoCalc);
      formData.append("ultimoPagamento", this.ultimoPagamento);
     

      axios
        .post("https://www2.royaljardim.com.br/sistema/iptu/salvarSeguro", formData)
        .then(res => {
          console.log(res.data);
          alert("Dados de Seguro salvos com sucesso!");
        })
        .catch((e) => {
          console.error(e);
          alert("Erro ao salvar os dados do Seguro.");
        });
    },
  },
  
};
</script>

<style scoped>
.icon-menu {
  width: 80px;
  height: 80px;
}
.link-locacao{
  text-decoration:none;

}
</style>